'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizrMiddleware;

var _normalizr = require('normalizr');

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizrMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        var schema = action.meta && action.meta.schema;

        if (schema && action.payload && !action.error) {
          var normalized = (0, _normalizr.normalize)(action.payload, schema);
          action = (0, _assign2.default)({}, action, { payload: normalized });
        }

        return next(action);
      };
    };
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-normalizr-middleware/lib.js
// module id = ./node_modules/redux-normalizr-middleware/lib.js
// module chunks = 2